import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(
    "/modello_camicia/colletto_basso_button_down_corto.gltf"
  );
  const { tessuto, bottoni, asole, fili, opa, matBottone, club, bottone } = props;
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface161.geometry}
        material={nodes.polySurface161.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        {club ? (
          <meshStandardMaterial
            color={"white"}
            roughness={1}
            toneMapped={false}
            side={2}
          />
        ) : (
          <meshStandardMaterial
            map={tessuto}
            roughness={1}
            toneMapped={false}
            side={2}
          />
        )}
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface12.geometry}
        material={nodes.polySurface12.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
        >
        <meshMatcapMaterial
          attach="material"
          matcap={matBottone}
          color={bottoni}
          map={bottone}
        />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.arch_collar_c_button_polySurface16.geometry}
        material={nodes.arch_collar_c_button_polySurface16.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
        >
        <meshMatcapMaterial
          attach="material"
          matcap={matBottone}
          color={bottoni}
          map={bottone}
        />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface13.geometry}
        material={nodes.polySurface13.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={asole} transparent={true} opacity={opa} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface9.geometry}
        material={nodes.polySurface9.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={asole} transparent={true} opacity={opa} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.arch_collar_c_thread_polySurface14.geometry}
        material={nodes.arch_collar_c_thread_polySurface14.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={fili} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.arch_collar_c_thread_polySurface15.geometry}
        material={nodes.arch_collar_c_thread_polySurface15.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={fili} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface11.geometry}
        material={nodes.polySurface11.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={fili} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.polySurface10.geometry}
        material={nodes.polySurface10.material}
        position={[0.03, 0.03, 0.01]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.08, 0.08, 0.08]}
      >
        <meshStandardMaterial color={fili} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/modello_camicia/colletto_basso_button_down_corto.gltf");
